import { makeStyles } from 'tss-react/mui';

export default makeStyles()(theme => ({
    fabButtons: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'center'
        }
    },
    fab: {
        position: "fixed",
        bottom: theme.spacing(2)
    },
    paper: {
        display: 'flex',
        justifyContent: 'center',
        padding: theme.spacing(2)
    }
}));